import {createSlice} from "@reduxjs/toolkit"

const initialState = {
  requisite: {
    loading: false,
    data: null,
  },

  checkPayment: {
    loading: false,
    data: null,
  }
}

const requisiteSlice = createSlice({
  name: 'requisite',
  initialState,
  reducers: {
    create(state, action) {

    },
    update(state, action) {

    },

    checkPayment(state, action) {

    },
    setCheckPayment(state, action) {
      const {payload} = action
      state.checkPayment.data = payload
    },
    setRequisite(state, action) {
      const {payload} = action
      state.requisite.data = payload
    },
    setLoading(state, action) {
      const {payload} = action
      state[payload.type].loading = payload.loading
    },
  },
})

const requisiteReducer = requisiteSlice.reducer

export {requisiteSlice, requisiteReducer}
